import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { BUSINESS } from "../data/business";
import { Reveal } from "./Reveal";

export const CTASection = () => (
  <section className="relative bg-ink grain overflow-hidden" data-testid="final-cta">
    <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-copper/10 blur-3xl" aria-hidden="true" />
    <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28 text-center">
      <Reveal>
        <p className="font-editorial italic text-copper text-xl sm:text-2xl mb-4">the chair is ready</p>
        <h2 className="font-display font-extrabold text-white leading-[1.05] text-[clamp(2.4rem,5.5vw,4.5rem)]">
          Ready for a Fresh Look?
        </h2>
        <p className="mt-5 text-white/60 text-base sm:text-lg max-w-xl mx-auto leading-relaxed">
          Contact New Lookz Hair Salon to ask about services, availability and your next appointment.
        </p>
        <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/book"
            data-testid="final-cta-book"
            className="w-full sm:w-auto rounded-full bg-copper px-9 py-4 font-display font-bold text-ink transition-all duration-300 hover:bg-copper-hover hover:-translate-y-0.5"
          >
            Book an Appointment
          </Link>
          <a
            href={BUSINESS.phoneHref}
            data-testid="final-cta-call"
            className="w-full sm:w-auto rounded-full border border-white/25 px-9 py-4 font-display font-semibold text-white inline-flex items-center justify-center gap-2 transition-all duration-300 hover:border-copper hover:text-copper"
          >
            <Phone size={17} aria-hidden="true" /> Call Now
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
